const Card = {
  init: () => {
    // find cards that shows the progress bar
    const cardsWithProgress = Array.from(
      document.querySelectorAll(".card--show-progress")
    );

    if (cardsWithProgress) {
      cardsWithProgress.forEach((card) => {
        // get the progress value
        const progressData = card.dataset.progress;

        // set the progress value
        if (progressData) {
          const progressBarValueEl = card.querySelector(
            ".card__progress__bar__value"
          );

          if (progressBarValueEl)
            progressBarValueEl.style = `width: ${progressData}%`;
        }
      });
    }
  },
};

export default Card;
